(() => {
  const ROOT_SELECTOR = '[data-offers-carousel]';

  const shuffle = (items) => {
    const shuffled = [...items];
    for (let index = shuffled.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [shuffled[index], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[index]];
    }
    return shuffled;
  };

  const initializeCarousel = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.offersReady === 'true') return;

    const viewport = root.querySelector('[data-offers-viewport]');
    const track = root.querySelector('[data-offers-track]');
    const previous = root.querySelector('[data-offers-prev]');
    const next = root.querySelector('[data-offers-next]');
    const cards = Array.from(root.querySelectorAll('[data-offer-card]'));

    if (!viewport || !track || cards.length === 0) return;

    root.dataset.offersReady = 'true';

    cards.forEach((card) => {
      card.classList.remove('is-selected');
      card.setAttribute('aria-hidden', 'true');
    });

    const selectedCards = shuffle(cards).slice(0, Math.min(10, cards.length));
    selectedCards.forEach((card) => {
      card.classList.add('is-selected');
      card.setAttribute('aria-hidden', 'false');
      track.appendChild(card);
    });

    const updateControls = () => {
      const atStart = viewport.scrollLeft <= 4;
      const atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4;

      if (previous) previous.disabled = atStart;
      if (next) next.disabled = atEnd;
    };

    const scrollAmount = () => Math.max(viewport.clientWidth * 0.82, 320);

    previous?.addEventListener('click', () => {
      viewport.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      viewport.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    requestAnimationFrame(updateControls);
  };

  const scan = (scope = document) => {
    if (scope instanceof HTMLElement && scope.matches(ROOT_SELECTOR)) {
      initializeCarousel(scope);
    }

    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initializeCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) scan(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(() => {
  if (window.__animalSapiensEducationMenuV7) return;
  window.__animalSapiensEducationMenuV7 = true;

  const TEXT_SELECTOR = [
    '.animal-sapiens-menu-v2 .text',
    '.animal-sapiens-menu-v2 .professional-mega-v3__quick-link',
    '.animal-sapiens-menu-v2 .professional-mega-v3__category-link > span:first-child',
    '.animal-sapiens-menu-v2 .professional-mega-v3__sublink > span:first-child',
    '.animal-sapiens-mobile-menu .text'
  ].join(',');

  const isCatalan = (document.documentElement.lang || '').toLowerCase().startsWith('ca');
  const replacements = isCatalan
    ? {
        Adiestramiento: 'Educació',
        Ensinistrament: 'Educació',
        Educación: 'Educació',
        'Collares educativos': 'Collars educatius',
        "Collars d'ensinistrament": 'Collars educatius',
        'Arneses educativos': 'Arnesos educatius',
        "Arnesos d'ensinistrament": 'Arnesos educatius'
      }
    : {
        Adiestramiento: 'Educación',
        Ensinistrament: 'Educación'
      };

  const normalizeElement = (element) => {
    if (!(element instanceof HTMLElement)) return;
    const rawText = element.textContent || '';
    const normalizedText = rawText.trim();
    const replacement = replacements[normalizedText];
    if (!replacement || replacement === normalizedText) return;
    element.textContent = rawText.replace(normalizedText, replacement);
  };

  const scanMenuLabels = (scope = document) => {
    if (scope instanceof HTMLElement && scope.matches(TEXT_SELECTOR)) normalizeElement(scope);
    scope.querySelectorAll?.(TEXT_SELECTOR).forEach(normalizeElement);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scanMenuLabels(), { once: true });
  } else {
    scanMenuLabels();
  }

  document.addEventListener('shopify:section:load', (event) => scanMenuLabels(event.target));

  const labelObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) scanMenuLabels(node);
      });
    });
  });

  labelObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
